import { IsBoolean, IsUUID } from 'class-validator';

export class MergeUsersDto {
  @IsUUID()
  targetUserId: string;

  @IsUUID()
  sourceUserId: string;

  /**
   * Identity fields are optional: a merge with none selected still moves the
   * source user's affiliations to the target and retires the source.
   */
  @IsBoolean()
  transferSub: boolean;

  @IsBoolean()
  transferOneLoginSub: boolean;

  @IsBoolean()
  transferKratosId: boolean;
}

export interface UserClinicalActivityDto {
  hasActivity: boolean;
  healthRecordCount: number;
  conditionCount: number;
  /** @deprecated Use conditionCount */
  skinConditionCount?: number;
  conditionTriageCount: number;
  /** @deprecated Use conditionTriageCount */
  skinConditionTriageCount?: number;
}
